import { Microfrontend } from '@thoughtspot/microfrontends';

export const MICRO_FRONTEND_DYNAMIC_IMPORT: { [key in Microfrontend]: any } = {
    [Microfrontend.ARSENAL]: () => import('@thoughtspot/arsenal'),
    [Microfrontend.EUREKA]: () => import('@thoughtspot/eureka'),
    [Microfrontend.EMBED_DEV_PORTAL]: () => import('@thoughtspot/embed'),
    [Microfrontend.HOME]: () => import('@thoughtspot/home'),
    [Microfrontend.DATA_MODEL]: () => import('@thoughtspot/datamodel'),
    [Microfrontend.ADMIN]: () => import('@thoughtspot/admin'),
    [Microfrontend.SEEKWELL]: () => import('@thoughtspot/seekwell'),
    [Microfrontend.SPOTTER]: () => import('@thoughtspot/spotter'),
    [Microfrontend.CONV_ASSIST]: () => import('@thoughtspot/conv-assist'),
    [Microfrontend.EDGE]: () => import('@thoughtspot/edge'),
    [Microfrontend.COPILOT]: () => import('@thoughtspot/copilot'),
    [Microfrontend.QUERY_VISUALIZER]: () =>
        import('@thoughtspot/query-visualizer'),
    [Microfrontend.TEAMS]: () => import('@thoughtspot/teams'),
    [Microfrontend.COMS]: () => import('@thoughtspot/coms'),
    [Microfrontend.MONITOR]: () => import('@thoughtspot/monitor'),
    [Microfrontend.GLOBAL_NAV]: () => import('@thoughtspot/global-nav'),
    [Microfrontend.WORKSHEET_V2]: () => import('@thoughtspot/worksheet-v2'),
    [Microfrontend.EMBRACE]: () => import('@thoughtspot/embrace'),
    [Microfrontend.CAPTAIN]: () => import('@thoughtspot/captain'),
    [Microfrontend.ONBOARDING]: () => import('@thoughtspot/onboarding'),
    [Microfrontend.SAGE_COACH]: () => import('@thoughtspot/sage-coach'),
    [Microfrontend.STATUS]: () => import('@thoughtspot/status'),
    [Microfrontend.NAVIGATION]: () => import('@thoughtspot/navigation'),
    [Microfrontend.EUREKA_DATA_MODEL]: () =>
        import('@thoughtspot/eureka-data-model'),
    [Microfrontend.LIVEBOARD]: () => import('@thoughtspot/liveboard'),
    [Microfrontend.AURORA]: () => import('@thoughtspot/aurora'),
    [Microfrontend.SPARKFLOW]: () => import('@thoughtspot/sparkflow'),
    [Microfrontend.FULL_USER_JOURNEY]: () =>
        import('@thoughtspot/full-user-journey'),
    [Microfrontend.AGENT_DB]: () => import('@thoughtspot/agent-db'),
    [Microfrontend.DATAAPPS]: () => import('@thoughtspot/dataapps'),
    [Microfrontend.SPOTTER_BENCHMARK]: () =>
        import('@thoughtspot/spotter-benchmark'),
    [Microfrontend.CONTEXT_LAYER]: () => import('@thoughtspot/context-layer'),
};
